<template>
  <div class="pa-3 grey lighten-4">
      <v-card class="mt-3">
        <v-card-title class="grey lighten-4 pa-2">
          <h3 class="secondary--text">
            {{ $t("screener.admin.company.theme_configuration") }}
            <v-tooltip top color="white">
              <template v-slot:activator="{ on }">
                <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span class="greyDarken3--text body-1">
                {{ $t("screener.admin.company.theme_configuration.tooltip") }}
              </span>
            </v-tooltip>
          </h3>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="onSave()" small>Save</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout  row wrap class="pt-2">
            <v-flex xs12 sm6 md6>
              <v-layout row wrap class="px-3 pb-4">
                <!-- Upload logo -->
                <v-flex xs12 md4 class="pa-0">
                  <v-container
                    bg
                    fill-height
                    grid-list-md
                    text-xs-center
                    py-0
                    pl-0
                  >
                    <v-layout row wrap align-center>
                      <v-flex class="pa-0">
                        <v-card
                          @click="showDropzoneLogoDialog = true">
                          <v-img
                            v-if="company.logo_url"
                            height="12vmin"
                            contain
                            :src="company.logo_url"
                          ></v-img>
                          <v-icon color="blue-grey lighten-4" style="font-size: 70px" v-else>mdi-cloud-upload</v-icon>
                          <v-card-title class="justify-center">
                            <v-chip
                                color="primary white--text font-weight-bold"
                              >{{ $t("screener.company.profile.upload_logo") }}
                            </v-chip>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <SingleFileUploader
                    key="upload_logo"
                    v-model="showDropzoneLogoDialog"
                    :title="$t('screener.company.profile.upload_logo')"
                    :warning="$t('screener.admin.drag_and_drop.warning')"
                    :attribute="'logo_url'"
                    :collection="this.DEFINES.COLLECTION_PUBLIC"
                    :dropzoneOptions="dropzoneOptions('uploadLogo')"
                    @setThumbnal="setThumbnail"
                    @onError="showError"
                  ></SingleFileUploader>
                </v-flex>
                <!-- Upload Footer Logo -->
                <v-flex xs12 md4 class="pa-0">
                  <v-container
                    bg
                    fill-height
                    grid-list-md
                    text-xs-center
                    py-0
                    pl-0
                  >
                    <v-layout row wrap align-center>
                      <v-flex class="pa-0">
                        <v-card
                          @click="showDropzoneFooterLogoDialog = true">
                          <v-img
                            v-if="company.footer_logo_url"
                            height="12vmin"
                            contain
                            :src="company.footer_logo_url"
                          ></v-img>
                          <v-icon color="blue-grey lighten-4" style="font-size: 70px" v-else>mdi-cloud-upload</v-icon>
                          <v-card-title class="justify-center">
                            <v-chip
                                color="primary white--text font-weight-bold"
                              >Upload Footer Logo
                            </v-chip>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <SingleFileUploader
                    key="upload_footer_logo"
                    v-model="showDropzoneFooterLogoDialog"
                    :title="'Upload Footer Logo'"
                    :warning="$t('screener.admin.drag_and_drop.warning')"
                    :attribute="'footer_logo_url'"
                    :collection="this.DEFINES.COLLECTION_PUBLIC"
                    :dropzoneOptions="dropzoneOptions('uploadFooterLogo')"
                    @setThumbnal="setThumbnail"
                    @onError="showError"
                  ></SingleFileUploader>
                </v-flex>
                <!-- Upload favicon -->
                <v-flex xs12 md4 class="pa-0">
                  <v-container
                    bg
                    fill-height
                    grid-list-md
                    text-xs-center
                    py-0
                    pl-0
                  >
                    <v-layout row wrap align-center>
                      <v-flex class="pa-0">
                        <v-card
                          @click="showDropzoneFaviconDialog = true">
                          <v-img
                            v-if="company.favicon_url"
                             height="12vmin"
                            contain
                            :src="company.favicon_url"
                          ></v-img>
                          <v-icon color="blue-grey lighten-4" style="font-size: 70px" v-else>mdi-cloud-upload</v-icon>
                          <v-card-title class="justify-center">
                            <v-chip
                                color="primary white--text font-weight-bold"
                              >
                                {{ $t("screener.company.profile.upload_favicon") }}
                              </v-chip>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <SingleFileUploader
                    key="upload_favicon"
                    v-model="showDropzoneFaviconDialog"
                    :title="$t('screener.company.profile.upload_favicon')"
                    :warning="$t('screener.admin.drag_and_drop.warning')"
                    :attribute="'favicon_url'"
                    :collection="this.DEFINES.COLLECTION_PUBLIC"
                    :dropzoneOptions="dropzoneOptions('uploadFavicon')"
                    @setThumbnal="setThumbnail"
                    @onError="showError"
                  ></SingleFileUploader>
                </v-flex>
              </v-layout>

              <!-- Theme -->
              <v-flex xs12 class="px-3">
                <v-switch
                  v-model="company.custom_properties.is_rtl"
                  :label="$t('screener.save.form.theme.rtl')"
                  color="primary"
                  value="true"
                ></v-switch>
                <v-switch
                  v-model="darkMode"
                  :label="$t('screener.save.form.theme.dark_mode')"
                  color="primary"
                  :value="true"
                ></v-switch>
                 <v-switch
                  v-model="company.custom_properties.use_logo_as_header_bg"
                  :label="$t('screener.admin.company.use_logo_as_header')"
                  color="primary"
                  value="true"
                ></v-switch>
                <v-switch
                  v-model="dynamicFooter"
                  :label="'Enable Dynamic Footer'"
                  color="primary"
                ></v-switch>
                <v-select
                  v-model="fontFamily"
                  :items="DEFINES.FONT_FAMILIES"
                  :label="'Theme Fonts'"
                  item-text="text"
                  item-value="value"
                  return-object
                >
                <!-- <template slot="selection" slot-scope="data" >
                  {{ data.item.text }} <span v-if="data.item.text == 'Custom Fonts'">( {{ data.item.value }} )</span>
                </template>
                <template slot="item" slot-scope="data" >
                  {{ data.item.text }}<span v-if="data.item.text == 'Custom Fonts' && data.item.value">( {{ data.item.value }} )</span>
                </template> -->
                <!-- Uncomment when custom font required -->
                 <!-- <template v-slot:append-item >
                   <v-divider></v-divider>
                    <div class="text-xs-center">
                    <div class="mt-3 title">Add your fonts</div>
                      <v-container>
                      <v-text-field
                        v-model="customFont.value"
                        :value="customFont.value"
                        :label="'Font Family Name'"
                        placeholder="Ex. Barlow"
                      />
                      <v-text-field
                        v-model="customFont.url"
                        :value="customFont.url"
                        :label="'Font TTF File Url'"
                        placeholder="http://fonts.gstatic.com/s/barlow/v5/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf"
                      />
                    </v-container>
                    <v-btn @click="setCustomFont" color="primary">Add custom fonts</v-btn>
                    </div>
                  </template> -->
                </v-select>
                <v-text-field
                  v-model="company.custom_properties.theme.primaryColor"
                  :color="company.custom_properties.theme.primaryColor"
                  :label="$t('screener.save.form.theme_primary_color')"
                  placeholder="Hex code e.g #FF0000"
                >
                  <template v-slot:append>
                    <!-- <InputColorPicker v-model="company.custom_properties.theme.primaryColor" /> -->
                  </template>
                </v-text-field>

                <v-text-field
                  v-model="company.custom_properties.theme.secondaryColor"
                  :color="company.custom_properties.theme.secondaryColor"
                  :label="$t('screener.save.form.theme_secondary_color')"
                  placeholder="Hex code e.g #FF0000"
                >
                  <template v-slot:append>
                    <!-- <InputColorPicker  v-model="company.custom_properties.theme.secondaryColor" /> -->
                  </template>
                </v-text-field>

                <v-text-field
                  v-model="company.custom_properties.theme.backgroundColor"
                  :color="company.custom_properties.theme.backgroundColor"
                  :label="$t('screener.save.form.theme_background_color')"
                  placeholder="Hex code e.g #FF0000"
                >
                  <template v-slot:append>
                    <!-- <InputColorPicker  v-model="company.custom_properties.theme.backgroundColor" /> -->
                  </template>
                </v-text-field>
                <!-- If SA has enabled branding flag, allow to edit -->
                 <v-text-field
                  v-if="company.show_company_branding"
                  id="powered_by_message"
                  :label="$t('screener.powered_by_message.label')"
                  :placeholder="$t('screener.powered_by_message.placeholder')"
                  name="powered_by_message"
                  type="text"
                  v-model="company.custom_properties.powered_by_message"
                  class="custom-placeholer-color"
                ></v-text-field>

              </v-flex>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-card class="grey lighten-4">
                <h3 class="secondary--text text-xs-center font-weight-bold pt-3">
                  {{$t('company.theme.preview')}}
                </h3>
                <v-card-text class="px-4 pb-4">
                 <CompanyThemePreview :company="company" :darkMode="darkMode" :fontFamily="fontFamily"/>
                 </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- Footer Configurations -->
      <v-card class="mt-3" v-if="dynamicFooter">
        <v-card-title class="grey lighten-4 pa-2">
          <h3 class="secondary--text">
            {{ $t('company_footer_setting_section_title') }}
            <v-tooltip top color="white">
              <template v-slot:activator="{ on }">
                <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span class="greyDarken3--text body-1">
                {{ $t('company_footer_setting_section_tooltip') }}
              </span>
            </v-tooltip>
          </h3>
          <v-spacer></v-spacer>
          <v-btn color="success" small @click="onSave">Save</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout  row wrap class="pt-2">
            <v-flex xs12>
              <ThemeFooterConfigurations 
                ref="FooterConfigurations"
                :properties="company.custom_properties"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <!-- Footer Configurations -->
  </div>
</template>
<script>
import DEFINES from '@/defines';
import CompanyThemePreview from '@/components/company/ThemePreview';
import ThemeFooterConfigurations from "@/components/company/ThemeFooterConfigurations";
import SingleFileUploader from "@/components/media/SingleFileUploader";
import { mapGetters } from "vuex";
import { buildHeaders } from "@/api/_manager";
// import InputColorPicker from 'vue-native-color-picker'

export default {
  name: "CompanyThemeConfig",
  props: {
      company: {
          type: Object,
          default: null
      }
  },
  components: {
    CompanyThemePreview,
    SingleFileUploader,
    ThemeFooterConfigurations
    // InputColorPicker
  },
  data() {
      return {
        darkMode : this.company.custom_properties.darkMode,
        fontFamily: this.company.custom_properties.fontFamily,
        customFont:DEFINES.FONT_FAMILIES[DEFINES.FONT_FAMILIES.length-1],
        showDropzoneLogoDialog: false,
        showDropzoneFooterLogoDialog: false,
        showDropzoneFaviconDialog: false,
        dynamicFooter:false
      }
  },
  created(){
    if (('footer_configurations' in this.company.custom_properties) && this.company.custom_properties.footer_configurations.enable_feature) {
        this.dynamicFooter = true
    }
  },
  watch:{
      darkMode:{
          handler:function(newVal,oldVal){
              // switch background and secondary on darkmode switch
              let bgColor = this.company.custom_properties.theme.backgroundColor;
              this.company.custom_properties.theme.backgroundColor = this.company.custom_properties.theme.secondaryColor;
              this.company.custom_properties.theme.secondaryColor = bgColor;
              this.company.custom_properties.darkMode = newVal;
          }
      },
    fontFamily:{
          handler:function(newVal,oldVal){
              this.company.custom_properties.fontFamily = newVal;
          }
      },
      company:{
          deep:true,
          handler:function(){
              this.$emit('update:company',this.company);
          }
      }
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
    }),
    userRoleInCompany() {
        return this.$store.getters["company/userRoleInCompany"](
            this.selected_company_id
        );
    },
  },
  methods: {
    dropzoneOptions(uploading_relative_path) {
      return {
          acceptedFiles: "image/*",
          url: `${this.DEFINES.BASE_API_URL}/member/company/${this.selected_company_id}/${uploading_relative_path}`,
          thumbnailWidth: 200,
          maxFilesize: 1, //MB
          chunking: true,
          chunkSize: 2000000, // Bytes
          destroyDropzone: false,
          headers: buildHeaders().headers,
      };
    },
    setThumbnail(event) {
      this.company[event.on] = event.value;
    },
    async showError(event) {
      try {
        await this.$store.dispatch("app/showMessage", {
          message: event.message,
          color: "error",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    onSave() {
        // this.company.reg_configuration = this.local_reg_configuration;
        // if (!this.company.reg_configuration.hasOwnProperty("send_reminder")) {
        //   this.local_reg_configuration.send_reminder = true;
        // }
        // if (!this.company.reg_configuration.hasOwnProperty("is_mobile_visible")) {
        //   this.local_reg_configuration.is_mobile_visible = true;
        // }

        // Add Footer COnfigurations in the custom properties object
        if (this.dynamicFooter) {
          this.company.custom_properties.footer_configurations = this.$refs.FooterConfigurations.footer_properties
        }else{
          this.company.custom_properties.footer_configurations = {
            enable_feature:false,
            configurations:{},
            data:{}
          }
        }

        this.$emit("onSave", this.company);
    },
    setCustomFont(){
      DEFINES.FONT_FAMILIES = DEFINES.FONT_FAMILIES.filter(item => {
        return item.text !== 'Custom Fonts'
      });
      DEFINES.FONT_FAMILIES.push(this.customFont);
      this.fontFamily = this.customFont;
    }
  }
};
</script>
